import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AdminHeader({ title, accent = "#FF007F" }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-4 mb-6">
      <button
        data-testid="back-to-dashboard"
        onClick={() => navigate("/admin")}
        className="h-14 px-4 rounded-xl bg-[#27272A] hover:bg-[#3f3f46] text-white font-bold flex items-center gap-2 active:scale-95 transition-transform duration-75"
      ><ArrowLeft className="w-6 h-6" /> BACK</button>
      <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight" style={{ color: accent }}>
        {title}
      </h1>
    </div>
  );
}
